module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEpSURBVHgBlVLbVYNAEJ0B/OeX4+PEDuxAOnBjA4YK1AqEEqwg2oChBDqwhHBOMHyab5WMM8CusC45er92Zu7deSJM4O26fiAihYj58UuUuThoOzZqEyMGS37OBqSyoSY7y0+enOK1qmdHCCKKYQJSxcee7s/zqBTb0yWycH1IKJA2hMf8pRETQQr/APMXRmwVtzMv7pWzPfZmaTM968eMyXNt7wmePQ/f+1gi8SlxcZpHKXZDa7OKz5TIfomLzyWOu91+JT9Z4RL6lbGdSBwGQw1gXHbqYVBSazUhkX9l+kdccUvhkD8Stx/0mRD9WysS2ly9Kuf5uYE7zR9fGPC+EW4OKItP7l1f2K/brlR1AeivYHDb0E0942kX8BdUql5U8+1rpbZ3U5xvElWCKIlFraoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/automation/script.png
// module id = d9dR
// module chunks = 46